import { SvgBase } from "../svg.base";

export const Event = () => (
  <SvgBase>
    <path
      fill="currentColor"
      d="M20 16h-5v5h5v-5zM19 5v2h-8V5H9v2H8c-1.11 0-1.99.9-1.99 2L6 23a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-1V5h-2zm3 18H8V12h14v11z"
    />
  </SvgBase>
);